export default __webpack_public_path__ + "static/media/disconnected.bcab67b1.svg";